var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"admin-admin mt-page"},[_c('crud-table',{attrs:{"title":_vm.$i18n.gt('LABEL_MANAGE_ADMINS'),"item-table":"super-admin","item-name":"Admin","new-item":_vm.newItem,"filters":_vm.filters,"display-fields":_vm.displayFields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }